import { colors, typography } from '@pray/shared/components/foundations';
import Text from '@pray/shared/components/ui/Text';
import { IntervalPlan } from '@pray/shared/services/studioService/credits/types';

export default function FreeTrialInfo({ product }: { product: IntervalPlan }) {
  if (!product.is_free_trial_enabled) return null;

  return (
    <div className="mt-6 flex flex-col gap-1 rounded-md bg-amber-500/10 p-3">
      <Text variant={typography.body_sm} color={colors.text_featured}>
        Free {formatTrialDuration(product)} trial
      </Text>
      <Text variant={typography.body_xs} color={colors.text_featured}>
        You won&apos;t be charged until your trial ends.
      </Text>
    </div>
  );
}

const formatTrialDuration = (product: IntervalPlan): string => {
  if (!product.is_free_trial_enabled || !product.free_trial_interval_count || !product.free_trial_interval) {
    return '';
  }

  const count = product.free_trial_interval_count;
  const interval = product.free_trial_interval;
  const pluralInterval = count === 1 ? interval : `${interval}s`;

  return `${count} ${pluralInterval}`;
};
